var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0C8.26333 0 0 8.26333 0 18.5C0 28.7367 8.26333 37 18.5 37C28.7367 37 37 28.7367 37 18.5C37 8.26333 28.7367 0 18.5 0ZM13.9367 11.2233C13.9367 8.75652 15.9922 6.78333 18.5 6.78333C21.0078 6.78333 23.0633 8.75659 23.0633 11.2233V12.909C23.0633 15.3758 21.0078 17.349 18.5 17.349C15.9922 17.349 13.9367 15.3757 13.9367 12.909V11.2233ZM26.8456 30.0111H10.1544C9.04437 30.0111 8.18118 29.1476 8.18118 28.1199C8.18118 23.1866 12.3746 19.1987 17.4723 19.1987H19.5279C24.6667 19.1987 28.819 23.2276 28.819 28.1199C28.819 29.1476 27.9558 30.0111 26.8457 30.0111H26.8456Z",
    fill: "#00436D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.c260eac4c03460dd92f7887a8ee0db69.svg";
export { ForwardRef as ReactComponent };